export default "__VITE_ASSET__OW0N0Q8___"